module.exports = __webpack_public_path__ + "img/bolsa-auxilio.77a7b651.svg";